import { render, staticRenderFns } from "./CultureAgeSelect.vue?vue&type=template&id=1a7eb58c&"
import script from "./CultureAgeSelect.vue?vue&type=script&lang=js&"
export * from "./CultureAgeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports